import { useApolloClient } from '@apollo/client'
import { AccountCircleOutlined, Close as CloseIcon } from '@mui/icons-material'
import { Box, Grid, IconButton, TextField, Typography, useTheme } from '@mui/material'
import { useParams } from 'react-router-dom'
import { MediaFragmentFragmentDoc, Image } from '../../../../../graphql/generated'
import useGetPublicAlbums from '../hooks/useGetPublicAlbums'

interface ImageDetailProps {
  id: string
  onClose: () => void
}

export default function PublicImageDetails({ id, onClose }: ImageDetailProps) {
  const theme = useTheme()
  const client = useApolloClient()
  const { userId, albumId } = useParams<{ userId?: string; albumId?: string }>()
  const media = client.readFragment<Image>({ id: `Image:${id}`, fragment: MediaFragmentFragmentDoc })
  const albums = useGetPublicAlbums()

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center" sx={{ padding: 2 }}>
        <Typography sx={{ fontSize: 18, color: '#081230' }} data-test="image-details-drawer">
          Details
        </Typography>
        <IconButton onClick={onClose} data-test="close" size="large">
          <CloseIcon />
        </IconButton>
      </Grid>
      <Grid
        container
        direction="row"
        alignItems="center"
        sx={{ borderTop: '1px solid #EAEAEA', borderBottom: '1px solid #EAEAEA', color: '#9195A4', padding: theme.spacing(2) }}
      >
        <AccountCircleOutlined fontSize="small" />
        <span style={{ marginLeft: '10px' }} data-test="username">
          {userId}
        </span>
      </Grid>
      <div style={{ padding: 16 }}>
        <Typography sx={{ color: '#9195A4' }}>Album</Typography>
        {albums.allAlbums &&
          albums.allAlbums
            .filter((a) => a.id === albumId)
            .map((a) => (
              <Typography
                key={a.id}
                sx={{
                  marginTop: theme.spacing(1),
                  marginBottom: theme.spacing(2),
                  padding: theme.spacing(1, 0),
                  textTransform: 'unset',
                  fontWeight: 500,
                  '& svg': {
                    marginRight: theme.spacing(1.5)
                  }
                }}
                color="primary"
              >
                {a.title}
              </Typography>
            ))}
        <Box mb={2}>
          <TextField
            data-test="title"
            label="Title"
            placeholder="Title"
            variant="outlined"
            fullWidth
            name="title"
            value={media?.title || 'No Information Available'}
            disabled
          />
        </Box>
        <Box mb={2}>
          <TextField
            data-test="description"
            label="Description"
            placeholder="Description"
            variant="outlined"
            multiline
            rows={4}
            fullWidth
            name="description"
            value={media?.description || 'No Information Available'}
            disabled
          />
        </Box>
      </div>
    </>
  )
}
